<template>
    <a :href="data.url" :title="data.title" class="dp-fx fx-al-ct mg-t-10">
        <div :style="{'background-image': `url(${(data.image !== '') ? data.image : defaultImage})`}" class="img" :alt="data.title" :title="data.title"></div>
        <div class="fz-14 lh-18 fw-4 cl-black mg-l-10">{{data.title}}</div>
    </a>
</template>

<script>
    export default {
        name : 'SearchSuggestionTile',
        props : {
            data : Object
        },
        components : {},
        data : function () {
            return {
                defaultImage : require('../assets/default-movie-poster.png')
            }
        },
        methods : {}
    }
</script>

<style>

</style>